<template>
  <div>
    <Card dis-hover>
      <p slot="title">流程角色</p>
      <div style="margin: 8px 16px">
        请输入角色名称：<Input v-model="search" style="width:300px" icon="ios-search"></Input>
      </div>
      <div class="contain">
        <Poptip trigger="hover" v-for="item in list" :key="item.id" placement="right">
        <!-- <Poptip v-for="item in list" :key="item.id" placement="right"> -->
          <corner v-show="item.allowLowEdit"></corner>
          <Button 
            type="dashed"
            icon="android-person" 
            style="width:100%;height:70px" 
            :class="{highLight: search&&item.name.indexOf(search) !== -1}">
            {{item.name}}
          </Button>
          <div slot="content">
            <ButtonGroup vertical style="width: 100%">
              <Button size="small" icon="edit" @click="edit(item)">编辑</Button>
              <Button size="small" icon="trash-a" @click="deleteRole(item)">删除</Button>
              <Button size="small" icon="ios-body" @click="getrole(item)">角色人员</Button>
            </ButtonGroup>
          </div>
        </Poptip>
        <Button @click="addRole" style="width:138px;height:70px;margin: 0 8px">
          <h1 style="color:#aaa">+</h1>
        </Button>
      </div>
    </Card>
    <Modal
      v-model="editModal"
      :title="title"
      @on-ok="ok"
      :loading="loading">
      角色名称：
      <Input v-model="modalInput" style="width:300px"></Input>
      <p style="margin-top: 12px">
        是否可编辑：
        <RadioGroup v-model="editable">
          <Radio label="是">
            <span>是</span>
          </Radio>
          <Radio label="否">
            <span>否</span>
          </Radio>
        </RadioGroup>
      </p>
    </Modal>
    <edit-member 
      title="流程角色人员"
      v-model="editMemberShow"
      :role_list="role_list" 
      :type_name="type_name" 
      :currentRole="currentRole" 
      @save-success="change_show">
    </edit-member>
  </div>
</template>

<script>
import ajax from '@/lib/ajax'
import userAjax from '@/lib/userAjax'
import corner from '@/components/corner'
import EditMember from './editMember.vue'

export default {
  components: {
    EditMember,
    corner
  },
  data() {
    return {
      list: [],
      search: '',
      currentRole: {},
      editMemberShow: false,
      role_list: [],
      type_name: '',  // 角色名
      title: 'erew5',
      editModal: false,
      modalInput: '',
      editable: '',
      loading: true
    }
  },
  computed: {
    user() {
      return this.$store.state.session.user
    }
  },
  async created(){
    this.init()
    },
  methods: {
    init() {
      // 获取角色列表
      userAjax.get('/api/services/app/BaseUserEmpRole/GetRoleList').then(res => {
        this.list = res.data.result.items
      })
    },
    addRole() {
      this.title = '添加角色'
      this.currentRole = {}
      this.modalInput = ''
      this.editModal = true
    },
    edit(item) {
      this.title = '编辑角色'
      this.currentRole = item
      this.modalInput = item.name
      this.editable = item.allowLowEdit == null ? '' : item.allowLowEdit === true ? '是' : '否'
      this.editModal = true
    },
    ok() {
      if (this.editable === '' || this.modalInput === '') {
        this.loading = false
        this.$Message.info('请完善信息填写')
        setTimeout(() => {
          this.loading = true
        },100)
        return
      }
      if (this.title === '添加角色') {
        userAjax.post('/api/services/app/BaseUserEmpRole/CreateOrUpdate', {
          baseUserRole: {
            name: this.modalInput,
            allowLowEdit: this.editable === '是' ? true : false
          }
        }).then(() => {
          this.$Message.success('添加成功！')
          this.init()
          this.editModal = false
        }).catch(() => {
          this.$Message.error('添加失败！')
        })
      }
      if (this.title === '编辑角色') {
        userAjax.post('/api/services/app/BaseUserEmpRole/CreateOrUpdate', {
          baseUserRole: {
            id: this.currentRole.id,
            name: this.modalInput,
            allowLowEdit: this.editable === '是' ? true : false
          }
        }).then(() => {
          this.$Message.success('编辑成功')
          this.init()
          this.editModal = false
        }).catch(() => {
          this.$Message.error('编辑失败！')
        })
      }
    },
    deleteRole(item) {
      this.$Modal.confirm({
        title: '删除角色',
        content: `<p>确定要删除角色：${item.name} 吗？</p>`,
        onOk: () => {
          userAjax.delete(`/api/services/app/BaseUserEmpRole/DeleteRole?Id=${item.id}`).then(() => {
            this.$Message.success('删除成功！')
            this.init()
          }).catch(() => {
            this.$Message.error('删除失败！')
          })
        },
        onCancel: () => {
        }
      });
    },
    async getrole(item) {
      this.currentRole = item
      this.role_list = []
      this.type_name = item.name
      let res = await userAjax.get(`/api/services/app/BaseUserEmpRole/GetUserListByRoleId?role_id=${item.id}`).then(res => {
        res.data.result.items.forEach((role,index) => {
          this.$set(role, 'fullName', role.name)
          this.$set(role, 'roleId', item.id)
        });
        this.role_list = res.data.result.items
        this.editMemberShow = true
      })
    },
    change_show(){
      this.editMemberShow = false
    }
  }
}
</script>

<style lang="less" scoped>
.contain {
  margin: 20px 8px 0;
}
.ivu-poptip {
  width: 11%;
  min-width: 138px;
  margin: 0 8px 2%;
  position: relative;
  /deep/.ivu-poptip-rel {
    width: 100%;
  }
  /deep/.ivu-poptip-popper {
    min-width: 100px;
    .ivu-poptip-body {
      padding: 0
    }
  }
}
.highLight {
  background-color: #FFFF66;
}
</style>